import * as Apis from '../../utils/apisRequest'

import * as APP from "@/utils/appRequest";
import * as API from "@/utils/apiRequest";



export default {
    //获取金币明细
    //https://apisdev.aigupiao.com/UserCenter/user_gold_detail/?appversion=11.8.0&u_id=44324&before=0
    async user_gold_detail(opt){
        return await Apis.get({
            url:'/UserCenter/user_gold_detail/',
            params: {
                ...opt
            }
        })
    },
    //获取用户协议
    //https://apisdev.aigupiao.com/v1/user/agreements?u_id=44324
    async agreement(opt){
        return await Apis.get({
            url:'/v1/user/agreements',
            params: {
                ...opt
            }
        })
    },
    //获取购买会员评论
    //https://apis.aigupiao.com/v2/userEvaluationOfTeachers/?l_id=120
    async userEvaluationOfTeachers(opt){
        return await Apis.get({
            url:'/v2/userEvaluationOfTeachers',
            params: {
                ...opt
            }
        })
    },

    //购买使用金币
    //https://apis.aigupiao.com/LiveBuyVip/user_platform_gold_limit/?appversion=11.8.0&balance_gold=1582&g_id=4281&&is_appointment=no&l_id=4476&origin_user_id=0&p_id=533&term=1&u_id=44324&user_id=44324
    async user_platform_gold_limit(opt){
        return await Apis.get({
            url:'/LiveBuyVip/user_platform_gold_limit/',
            params: {
                ...opt
            }
        })
    },

    //获取购买会员相关
    //https://apis.aigupiao.com/LiveBuyVip/index/?appversion=11.7.0&u_id=44324&l_id=120
    async LiveBuyVip(opt){
        return await Apis.get({
            url:'/LiveBuyVip/index/',
            params: {
                ...opt
            }
        })
    },

    //

    async warning(opt) {
        //https://appdev.aigupiao.com/api/support.php?act=warning&id=11
        let res = await APP.get({
            url: "/api/support.php?act=warning",
            params: {
                ...opt
            }
        });
        return res;
    },

    //检查微信是否绑定接口
    async bindWeChatCheck(opt) {
        //https://appdev.aigupiao.com/goapi/user/bindWeChatCheck
        let res = await APP.post({
            url: "/goapi/user/bindWeChatCheck",
            params: {
                ...opt
            }
        });
        return res;
    },

    async user_sign_see(opt) {
        //https://appdev.aigupiao.com/api2/live.php?act=user_sign_see&l_id=46&u_id=317961&order_id=G4124286
        let res = await APP.get({
            url: "/api2/live.php?act=user_sign_see&l_id=46&u_id=317961&order_id=G4124286",
            params: {
                ...opt
            }
        });
        return res;
    },
    async idCard(opt) {
        //https://appdev.aigupiao.com/goapi/idCard/auth
        let res = await APP.post({
            url: "/goapi/idCard/auth",
            params: {
                ...opt
            }
        });
        return res;
    },

    async real_info(opt) {
        //https://apidev.aigupiao.com/v1/user/real_info
        let res = await API.get({
            url: "/v1/user/real_info",
            params: {
                ...opt
            }
        });
        return res;
    },

    async agreementSign(opt) {
        //https://apisdev.aigupiao.com/PaySign/liver
        let res = await Apis.post({
            url: "/PaySign/liver",
            params: {
                ...opt
            }
        });
        return res;
    },
    

    
    //购买会员
    //https://apisdev.aigupiao.com/Payment/liver_vip/?
    async Payment(opt){
        return await Apis.get({
            url:'/Payment/liver_vip/',
            params: {
                ...opt
            }
        })
    },
}
